import { Container } from '@/components/shared/container'
import { RichText } from '@/components/shared/rich-text'
import { SectionHeader } from '@/components/shared/section-header'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { BlokProps } from '@/lib/types'
import { FaqStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable } from '@storyblok/react/rsc'

export function Faq({ blok }: BlokProps<FaqStoryblok>) {
  return (
    <section
      {...storyblokEditable(blok)}
      className={'border-border border-y py-16'}
    >
      <Container>
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-2.5">
          <div>
            <SectionHeader
              icon={blok.descriptorIcon}
              preTitle={blok.descriptorTitle}
              title={blok.title}
              content={blok.content}
              layout={'stacked'}
            />
          </div>
          <div>
            <Accordion type="single">
              {blok.items?.map((item, index) => (
                <AccordionItem
                  {...storyblokEditable(item)}
                  key={item._uid}
                  value={item._uid}
                >
                  <AccordionTrigger key={item._uid + item.title}>{item.title}</AccordionTrigger>
                  <AccordionContent key={item._uid + 'content'}>
                    <RichText content={item.content} />
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </Container>
    </section>
  )
}
